import React from 'react';
import * as prosConnect from "../prodect/ProsConnect";

import {
    getHelpContent,
    getHelpContentByName,
    hasShowVersionInfo,
    hasHelp,
    subscribeToHelpRefreshed,
    TAG_KEEP_OPEN,
    unSubscribeToHelpRefreshed, setVersionInfoShown, isCustomerHelpAvailable
} from "../prodect/HelpManager";
import {ATTR_PDF_NAME, STR_NO_VALUE, STR_YES} from "../prodect/ProsConnect";
import {openUrl, VideoPlayer} from "../prodect/ProsCommonUi";
import {prosPopupOpenSendFeedback} from "../prodect/ProsPopup";
import BasicButton from "../components/BasicButton";
import Spacer from "../components/Spacer";
import {TimerTextInput} from "../components/TextInput";
import LoadingAnimation from "../components/LoadingAnimation";
import TabsNavigation from "../components/TabsNavigation";
import UiImage from "../components/UiImage";
import AccordionDropdown from "../components/AccordionDropdown";

function HelpDesk(props) {
    const [helpScope, sethelpScope] = React.useState("")
    const [, sethelpContext] = React.useState("")
    const [filterText, setFilterText] = React.useState("")

    React.useEffect(() => {
        function handleHelpUpdated(viewContext) {
            let currentScope = helpScope ? helpScope : 'currentViewTips'
            let scope = hasShowVersionInfo() ? currentScope : 'versionInfo'
            sethelpScope(scope)
            sethelpContext(viewContext)
        }
        sethelpScope('')
        subscribeToHelpRefreshed(handleHelpUpdated, props.host)
        // Specify how to clean up after this effect:
        return function cleanup() {
            unSubscribeToHelpRefreshed(props.host);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, helpScope, filterText])

    function toggleHelpScope(newContent) {
        setVersionInfoShown()
        sethelpScope(newContent)
    }
    require('./assets/scss/HelpDesk.scss')
    return <div id={"scroll-y"}>
        <header>
            <h1>Ohje</h1>
            <div className={"btn-set_right"}>
                <BasicButton
                    btnClass={"primary"}
                    icon={"mail"}
                    iconColor={"light"}
                    action={()=>{
                        prosPopupOpenSendFeedback(this)
                    }}
                    tooltip={["Lähetä palaute", "tooltip-left_bottom"]}
                />
                <BasicButton
                    btnClass={"primary"}
                    icon={"times"}
                    iconColor={"light"}
                    action={()=>{
                        props.closeHelpDesk()
                    }}
                />
            </div>
        </header>
        <HelpContentToggle toggleHelpScope={toggleHelpScope} helpScope={helpScope} />
        <Spacer/>
        <InfoContentFilter filterText={filterText} setFilterText={setFilterText} />
        {hasHelp() ?
            <>
                <VersionInfoItems/>
                <InfoProjectItems helpScope={helpScope} filterText={filterText}/>
            </>
            :
            <>
                <Spacer />
                <LoadingAnimation color={"var(--color-gray-40)"} />
            </>
        }
    </div>
}

function HelpContentToggle(props) {
    let linkValues = [{
        value: 'currentViewTips',
        text: 'Näyttökohtaiset',
        selected: props.helpScope === "currentViewTips"
    },{
        value: 'productIntro',
        text: 'Yleiset',
        selected: props.helpScope === "productIntro"
    }]
    if (isCustomerHelpAvailable()) {
        linkValues.unshift({
            value: 'customerHelp',
            text: 'Projektin ohje',
            selected: props.helpScope === "customerHelp"
        })
    } else if (props.helpScope === "customerHelp") {
        props.toggleHelpScope('currentViewTips')
    }
    let currentTab = linkValues.indexOf(linkValues.find(link => link.selected))
    return <TabsNavigation
        currentTab={currentTab ? currentTab : 0}
        values={linkValues}
        callback={val => props.toggleHelpScope(val)}
        btnClass={"primary"}
        className={"margin-top padding-0"}
    />
}

function InfoContentFilter(props) {
    return <TimerTextInput
        placeholder={"Hae ohjeista"}
        value={props.filterText}
        timerCallback={(val)=> {
            props.setFilterText(val)
        }}
    />
}

function VersionInfoItems() {
    if (hasShowVersionInfo()) {
        return null
    }
    const infoElements = getHelpContentByName('versionInfo')
    return (infoElements.map((header, i) => {
            let showHelpReportOpened = i < 2
            return <TextBlock
                key={i}
                header={header}
                keepOpen={showHelpReportOpened}
            />
        })
    )
}

function InfoProjectItems(props) {
    const infoElements = getHelpContent(props.filterText, props.helpScope)
    if (infoElements.length < 1) {
        if (props.filterText) {
            return <p>Hakusi ei vastaa yhtään ohjetta.</p>
        }
        if (props.helpScope === "currentViewTips") {
            return <p>Tästä näkymästä ei ole näyttökohtaisia ohjeita.</p>
        }
        if (props.helpScope === "customerHelp") {
            return <p>Tässä projektissa ei ole asetettuja ohjeita.</p>
        }
        return <p>Oppaan lataaminen epäonnistui.</p>
    }
    if (!Array.isArray(infoElements)) {
        return <p>Ei opastetta?</p>
    }
    return infoElements.map((header, i) => {
        let showHelpReportOpened = props.filterText ||
            ((props.helpScope === "currentViewTips" || props.helpScope === "customerHelp") && i === 0)
            return <TextBlock
                key={i}
                header={header}
                keepOpen={showHelpReportOpened}
            />
        }
    )
}

function TextBlock(props) {
    const [showInfoContent, setInfoContent] = React.useState(false)
    return props.header.obsList.length ?
        <>
            <h2 onClick={() => setInfoContent(!showInfoContent || props.keepOpen)}
                className={"margin-top icon-text-set"}>
                {props.keepOpen ? null : <i className={"ui-icon ui-icon-md ui-icon_color-light ui-icon-"+ (showInfoContent ? "chevron-down" : "chevron-right")} />}
                <span>{props.header.text}</span>
            </h2>
            <InfoReportContent
                showInfoContent={showInfoContent || props.keepOpen}
                content={props.header.obsList}
            />
        </>
        :
        null
}

function renderVideo(item) {
    return <div key={item.obj_id + 'v'} className={"box-media"}>
        <VideoPlayer
            item={item}
            playbackRate={0.75}
        />
    </div>
}

function openAsPdf(item) {
    if (item.hasOwnProperty(ATTR_PDF_NAME)) {
        let url = prosConnect.getItemPdfPath(item)
        if (url) {
            openUrl(url)
            return true
        }
    }
    return false
}

function InfoPicture(props) {
    const [expand, setExpand] = React.useState(false)
    const hasPdf = props.item.hasOwnProperty(ATTR_PDF_NAME)
    return <div
            onClick={evt => {
                setExpand(false)
            }}
            className={"box-media" + (expand ?" box-media-full" : "")}
        >
        <div
            className={"media media-image"}
        >
            <UiImage
                imageSrc={prosConnect.getItemImagePath(props.item)}
                action={evt => {
                    if (!openAsPdf(props.item)) {
                        setExpand(!expand)
                    }
                }}
                className={hasPdf ? "has-pdf" : null}
                alt={"ohjekuva"}
            >
                {hasPdf && <i className={"ui-icon ui-icon-xl ui-icon_color-light ui-icon-download"}/>}
            </UiImage>
        </div>
    </div>
}

function InfoParagraphContent(props) {
    const title = props.obs.text !== STR_NO_VALUE ? <h3>{props.obs.text}</h3> : null
    const content =  props.obs.obsObjList.map((item, i) => {
        switch (prosConnect.renderType(item)) {
            case 'pict':
                return <InfoPicture item={item} key={i}/>
            case 'video':
                return renderVideo(item)
            default:
                return item.text !== STR_NO_VALUE ? <p key={i}>{item.text}</p> : null
        }
    })
    if (!props.mayClose) {
        return <div className={"slab"}>
            {title}
            {content}
        </div>
    }
    return <AccordionDropdown
            closeable={props.mayClose || true}
            header={title}
            //initiallyOpen={true}
            //dynamicOpen={!props.mayClose}
        >
        {content}
    </AccordionDropdown>
}

function InfoReportContent(props) {
    if (!props.showInfoContent) {
        return null
    }
    return props.content.map((obs, i) => {
        return <InfoParagraphContent
            key={i}
            mayClose= {obs[TAG_KEEP_OPEN] === STR_YES}
            obs={obs}
        />
    })
}

export default HelpDesk
